'use client'

import { ReactNode } from 'react'
import { LazyMotion, domAnimation, m, MotionConfig } from 'framer-motion'

interface MotionProviderProps {
  children: ReactNode
}

/**
 * MotionProvider ensures Framer Motion is properly initialized
 * and provides a consistent configuration across the app
 */
export function MotionProvider({ children }: MotionProviderProps) {
  return (
    <LazyMotion features={domAnimation} strict>
      <MotionConfig reducedMotion="user">
        {children}
      </MotionConfig>
    </LazyMotion>
  )
}

// Export the 'm' component for use in other components
// This is the correct way to use motion components with LazyMotion
export { m as motion } 